// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRemainderDto } from './IRemainderDto';
import {
    IRemainderDtoFromJSON,
    IRemainderDtoFromJSONTyped,
    IRemainderDtoToJSON,
    IRemainderDtoToJSONTyped,
} from './IRemainderDto';
import type { ILockboxDtoDetails } from './ILockboxDtoDetails';
import {
    ILockboxDtoDetailsFromJSON,
    ILockboxDtoDetailsFromJSONTyped,
    ILockboxDtoDetailsToJSON,
    ILockboxDtoDetailsToJSONTyped,
} from './ILockboxDtoDetails';
import type { IClaimRepaymentDto } from './IClaimRepaymentDto';
import {
    IClaimRepaymentDtoFromJSON,
    IClaimRepaymentDtoFromJSONTyped,
    IClaimRepaymentDtoToJSON,
    IClaimRepaymentDtoToJSONTyped,
} from './IClaimRepaymentDto';

/**
 * 
 * @export
 * @interface IUpdateLockboxAggregatorDto
 */
export interface IUpdateLockboxAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof IUpdateLockboxAggregatorDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IUpdateLockboxAggregatorDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IUpdateLockboxAggregatorDto
     */
    vendor_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IUpdateLockboxAggregatorDto
     */
    liquidate_all_funds?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IUpdateLockboxAggregatorDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IUpdateLockboxAggregatorDto
     */
    lockbox_type: IUpdateLockboxAggregatorDtoLockboxTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IUpdateLockboxAggregatorDto
     */
    lockbox_status: IUpdateLockboxAggregatorDtoLockboxStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IUpdateLockboxAggregatorDto
     */
    reason?: IUpdateLockboxAggregatorDtoReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof IUpdateLockboxAggregatorDto
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdateLockboxAggregatorDto
     */
    form_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdateLockboxAggregatorDto
     */
    payment_method_type?: IUpdateLockboxAggregatorDtoPaymentMethodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IUpdateLockboxAggregatorDto
     */
    wire_status_type?: IUpdateLockboxAggregatorDtoWireStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IUpdateLockboxAggregatorDto
     */
    check_benefit_of?: string;
    /**
     * 
     * @type {Array<IClaimRepaymentDto>}
     * @memberof IUpdateLockboxAggregatorDto
     */
    claim_repayments?: Array<IClaimRepaymentDto>;
    /**
     * 
     * @type {IRemainderDto}
     * @memberof IUpdateLockboxAggregatorDto
     */
    remainder?: IRemainderDto;
    /**
     * 
     * @type {ILockboxDtoDetails}
     * @memberof IUpdateLockboxAggregatorDto
     */
    details?: ILockboxDtoDetails;
}

/**
* @export
* @enum {string}
*/
export enum IUpdateLockboxAggregatorDtoLockboxTypeEnum {
    UNKNOWN = 'UNKNOWN',
    INBOUND_TOA = 'INBOUND_TOA',
    OUTBOUND_TOA = 'OUTBOUND_TOA',
    RETURNED_CHECK = 'RETURNED_CHECK',
    CLAIM_REPAYMENT = 'CLAIM_REPAYMENT',
    BENEFICIARY = 'BENEFICIARY',
    HSA_FORM = 'HSA_FORM',
    MISTAKEN_DISTRIBUTION = 'MISTAKEN_DISTRIBUTION',
    HSA_ROLLOVER_FORM = 'HSA_ROLLOVER_FORM',
    HSA_CONTRIBUTION_FORM = 'HSA_CONTRIBUTION_FORM',
    HSA_TRANSFER_DIVORCE = 'HSA_TRANSFER_DIVORCE',
    HSA_ACCOUNT_CLOSURE = 'HSA_ACCOUNT_CLOSURE',
    COMBINE_HSA = 'COMBINE_HSA',
    DEATH_DISTRIBUTION = 'DEATH_DISTRIBUTION',
    POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
    RETURNED_MAIL = 'RETURNED_MAIL',
    EXCESS_CONTRIBUTION = 'EXCESS_CONTRIBUTION'
}
/**
* @export
* @enum {string}
*/
export enum IUpdateLockboxAggregatorDtoLockboxStatusEnum {
    NEW = 'NEW',
    PENDING = 'PENDING',
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    INVESTMENTS_LIQUIDATED = 'INVESTMENTS_LIQUIDATED',
    CANCELED = 'CANCELED',
    DIVIDED = 'DIVIDED',
    PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
    PROCESSED_MANUALLY = 'PROCESSED_MANUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IUpdateLockboxAggregatorDtoReasonEnum {
    CHECK = 'CHECK',
    WIRE = 'WIRE',
    PARTICIPANT_NOT_FOUND = 'PARTICIPANT_NOT_FOUND',
    ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
    INVESTMENTS_LIQUIDATION_REQUIRED = 'INVESTMENTS_LIQUIDATION_REQUIRED',
    ACCOUNT_CLOSED = 'ACCOUNT_CLOSED',
    INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
    OTHER = 'OTHER',
    CLAIM_NOT_FOUND = 'CLAIM_NOT_FOUND'
}
/**
* @export
* @enum {string}
*/
export enum IUpdateLockboxAggregatorDtoPaymentMethodTypeEnum {
    CHECK = 'CHECK',
    WIRE = 'WIRE'
}
/**
* @export
* @enum {string}
*/
export enum IUpdateLockboxAggregatorDtoWireStatusTypeEnum {
    SENT = 'SENT',
    NOT_SENT = 'NOT_SENT'
}


/**
 * Check if a given object implements the IUpdateLockboxAggregatorDto interface.
 */
export function instanceOfIUpdateLockboxAggregatorDto(value: object): value is IUpdateLockboxAggregatorDto {
    if (!('lockbox_type' in value) || value['lockbox_type'] === undefined) return false;
    if (!('lockbox_status' in value) || value['lockbox_status'] === undefined) return false;
    return true;
}

export function IUpdateLockboxAggregatorDtoFromJSON(json: any): IUpdateLockboxAggregatorDto {
    return IUpdateLockboxAggregatorDtoFromJSONTyped(json, false);
}

export function IUpdateLockboxAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUpdateLockboxAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'vendor_id': json['vendor_id'] == null ? undefined : json['vendor_id'],
        'liquidate_all_funds': json['liquidate_all_funds'] == null ? undefined : json['liquidate_all_funds'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'lockbox_type': json['lockbox_type'],
        'lockbox_status': json['lockbox_status'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'form_name': json['form_name'] == null ? undefined : json['form_name'],
        'payment_method_type': json['payment_method_type'] == null ? undefined : json['payment_method_type'],
        'wire_status_type': json['wire_status_type'] == null ? undefined : json['wire_status_type'],
        'check_benefit_of': json['check_benefit_of'] == null ? undefined : json['check_benefit_of'],
        'claim_repayments': json['claim_repayments'] == null ? undefined : ((json['claim_repayments'] as Array<any>).map(IClaimRepaymentDtoFromJSON)),
        'remainder': json['remainder'] == null ? undefined : IRemainderDtoFromJSON(json['remainder']),
        'details': json['details'] == null ? undefined : ILockboxDtoDetailsFromJSON(json['details']),
    };
}

export function IUpdateLockboxAggregatorDtoToJSON(json: any): IUpdateLockboxAggregatorDto {
    return IUpdateLockboxAggregatorDtoToJSONTyped(json, false);
}

export function IUpdateLockboxAggregatorDtoToJSONTyped(value?: IUpdateLockboxAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'account_id': value['account_id'],
        'vendor_id': value['vendor_id'],
        'liquidate_all_funds': value['liquidate_all_funds'],
        'amount': value['amount'],
        'lockbox_type': value['lockbox_type'],
        'lockbox_status': value['lockbox_status'],
        'reason': value['reason'],
        'notes': value['notes'],
        'form_name': value['form_name'],
        'payment_method_type': value['payment_method_type'],
        'wire_status_type': value['wire_status_type'],
        'check_benefit_of': value['check_benefit_of'],
        'claim_repayments': value['claim_repayments'] == null ? undefined : ((value['claim_repayments'] as Array<any>).map(IClaimRepaymentDtoToJSON)),
        'remainder': IRemainderDtoToJSON(value['remainder']),
        'details': ILockboxDtoDetailsToJSON(value['details']),
    };
}

